import { CHAT_MEDIA_TYPES, type ChatMediaType } from 'cpool-constants';

import Spinner from '~/components/icons/Spinner';
import { useChatMediaUrl } from '~/features/whatsapp/hooks/useChatMediaUrl';

type Props = {
    chatId: string;
    mediaKey: string;
    mediaType: ChatMediaType;
};

export const InlineMediaAttachment = ({ chatId, mediaKey, mediaType }: Props) => {
    const { blobUrl, isError, isLoading } = useChatMediaUrl(chatId, mediaKey);

    if (isLoading || (!blobUrl && !isError)) {
        return (
            <div className="flex h-24 w-40 items-center justify-center rounded-md bg-grey-light">
                <Spinner className="h-5 w-5" />
            </div>
        );
    }

    if (isError || !blobUrl) {
        return <div className="text-xs text-alert-error">{mediaKey}</div>;
    }

    if (mediaType === CHAT_MEDIA_TYPES.VIDEO) {
        return <video src={blobUrl} controls className="max-h-60 max-w-60 rounded-md" />;
    }

    return <audio src={blobUrl} controls className="max-w-60" />;
};
